<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

/**
 * Basic-table component
 */
export default {
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Permission List",
      items: [
        {
          text: "Permission",
          href: "/",
        },
        {
          text: "Permission List",
          active: true,
        },
      ],
      permissions: [],
    };
  },
  mounted() {
    this.getPermissionList();
  },
  methods: {
    async getPermissionList() {
      try {
        axios
          .get("/api/permission_list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.status == 200) {
              this.permissions = response.data.data;

              console.log(this.permissions);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    deleteItem: function deleteItem(permission) {
      var _this = this;
      axios
        .post("/api/permission_delete/" + permission.id, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
          _this.getPermissionList();
          _this.hasDeleted = false;
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">All Permissions</h4>
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Permision Name</th>
                    <th>Permision Type</th>
                    <th>Permision Tag</th>
                    <th>Permision Category</th>
                    <th>####</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(permission,index) in permissions" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                    <td>{{permission.name}}</td>
                    <td>{{permission.type}}</td>
                    <td>{{permission.tag}}</td>
                    <td>{{permission.category}}</td>
                    <td><router-link :to="{ name: 'permission_update', params: {id: permission.id } }" class="btn btn-primary btn-small"><i class="fas fa-edit"></i> Edit</router-link> <button @click.prevent="deleteItem(permission)" class="btn btn-danger btn-small"><i class="fa fa-trash"></i> Delete</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>